import { connect } from 'react-redux';

import CognitoFormEditScreen from '../components/CognitoFormEditScreen';

const mapStateToProps = (state) => {
  return {
    isLoading: state.cognitoForms.get('isLoading'),
    success: state.cognitoForms.getIn(['form', 'success']),
  };
};

const CognitoFormEditScreenContainer = connect(mapStateToProps)(
  CognitoFormEditScreen
);

export default CognitoFormEditScreenContainer;
